export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const script = document.createElement('script')
    script.async = true
    script.setAttribute('data-id', '101489167')
    script.src = '//static.getclicky.com/js'
    document.body.appendChild(script)
  }
})
